import { render } from "./Join.vue?vue&type=template&id=c8a9e256&scoped=true"
const script = {}

import "./Join.vue?vue&type=style&index=0&id=c8a9e256&lang=scss&scoped=true"

import exportComponent from "/var/www/html/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8a9e256"]])

export default __exports__